import { http, getUrl } from '@/utils/http'

export const UPLOAD_URL = getUrl('?r=certificate-apply/upload')

export const getCode = async function (params = {}) {
  const url = '?r=login/sms'
  const { data } = await http(url, params, 'GET')
  return data
}

export const login = async function (params = {}) {
  const url = '?r=login/login'
  const { data } = await http(url, params, 'POST')
  return data
}

export const getUserInfo = async function (params = {}) {
  const url = '?r=user/info'
  const { data } = await http(url, params, 'GET')
  return data
}

export const modifyUserInfo = async function (params = {}) {
  const url = '?r=user/modify'
  const { data } = await http(url, params, 'POST')
  return data
}

export const userLogout = async function (params = {}) {
  const url = '?r=login/out'
  const { data } = await http(url, params, 'GET')
  return data
}

export const resetPwd = async function (params = {}) {
  const url = '?r=user/reset'
  const { data } = await http(url, params, 'POST')
  return data
}

export const getEducationLevels = async function (params = {}) {
  const url = '?r=certificate-apply/get-education'
  const { data } = await http(url, params, 'GET')
  return data
}

export const getProvinces = async function (params = {}) {
  const url = '?r=certificate-apply/provinces'
  const { data } = await http(url, params, 'GET')
  return data
}

export const adultexamApply = async function (params = {}) {
  const url = '?r=certificate-apply/create'
  const { data } = await http(url, params, 'POST')
  return data
}

export const adultexamApplyInfo = async function (params = {}) {
  const url = '?r=certificate-apply/info'
  const { data } = await http(url, params, 'GET')
  return data
}

//生成登录二维码
export const loginQrcode = async function (params = {}) {
  const url = '?r=login/qrcode'
  const { data } = await http(url, params, 'GET')
  return data
}

//查询二维码状态
export const loginQrcodeCheck = async function (params = {}) {
  const url = '?r=login/qrcode-check'
  const { data } = await http(url, params, 'GET')
  return data
}



// WEBPACK FOOTER //
// ./src/server/me.js